import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../auth.service';
import { TokenManager } from '../tokens/token-manager';

const redirectLogin = (state: RouterStateSnapshot): void => {
  const authService = inject(AuthService);
  const router = inject(Router);

  authService.logout(false);

  router.navigate(['/auth/login'], { replaceUrl: true });
};

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean => {
  const isOutOfDate = TokenManager.isExpired();
  try {
    if (isOutOfDate) {
      redirectLogin(state);
      return false;
    }
  } catch {
    redirectLogin(state);
    return false;
  }
  return true;
};
